export const AUTO_OFFICE_COMMENTS = {
  NO_AVAILABLE_BALANCE: 'אין יתרה זמינה בפרויקט לבקשה',
  EXCEEDS_ELIGIBILITY: 'מעל מגבלת הזכאות ללקוח',
  CANCELLED_BY_REPRESENTATIVE: 'בוטל ע"י הרכז',
} as const;

/** Wording saved on requests before the קרן→פרויקט rename; still shown in the office UI. */
export const LEGACY_AUTO_OFFICE_COMMENTS = {
  NO_AVAILABLE_BALANCE: 'אין יתרה זמינה בקרן לבקשה',
} as const;

export type AutoOfficeComment = typeof AUTO_OFFICE_COMMENTS[keyof typeof AUTO_OFFICE_COMMENTS];

export const AUTO_OFFICE_COMMENTS_VALUES: string[] = [
  ...Object.values(AUTO_OFFICE_COMMENTS),
  LEGACY_AUTO_OFFICE_COMMENTS.NO_AVAILABLE_BALANCE,
];

